import generateUtilityClass from '../../utils/generateUtilityClass/generateUtilityClass.js';
import generateUtilityClasses from '../../utils/generateUtilityClasses/generateUtilityClasses.js';

function getSvgIconUtilityClass(slot) {
  return generateUtilityClass('MuiSvgIcon', slot);
}
generateUtilityClasses('MuiSvgIcon', ['root', 'colorPrimary', 'colorSecondary', 'colorAction', 'colorError', 'colorDisabled', 'fontSizeInherit', 'fontSizeSmall', 'fontSizeMedium', 'fontSizeLarge']);

export { getSvgIconUtilityClass };
//# sourceMappingURL=svgIconClasses.js.map
